module.exports = __webpack_public_path__ + "static/img/supplier1.png";